import { ButtonVariant, ButtonType, Button } from '@ampol/design-system';
import type { ReactNode } from 'react';
import clsx from 'clsx';

export interface PanelButton {
  label: string;
  variant?: ButtonVariant;
  type?: ButtonType;
  formId?: string;
  onClick?: () => void;
}

interface SmallPanelProps {
  children: ReactNode;
  title: string;
  formId?: string;
  disabled?: boolean;
  buttons?: PanelButton[];
  headless?: boolean;
}

const SmallPanel = ({ children, title, disabled = false, headless, buttons = [] }: SmallPanelProps) => (
  <div className={clsx('p-s bg-background-light flex-1 flex flex-col', headless && 'bg-white p-0')}>
    {!headless && <h3 className='mb-m'>{title}</h3>}
    <div className={clsx(disabled && 'pointer-events-none')}>
      <div className='box-border h-full'>{children}</div>
    </div>
    <div className='mt-auto pt-xl flex flex-col gap-xs'>
      <div className={clsx(disabled && 'pointer-events-none opacity-50')}>
        {buttons.map((button) => (
          <Button
            key={button.label}
            color='blue'
            label={button.label}
            variant={button?.variant ?? ButtonVariant.Primary}
            type={button?.type ?? ButtonType.Submit}
            className='!w-full'
            formId={button.formId}
            onClick={button.onClick}
          />
        ))}
      </div>
    </div>
  </div>
);

export default SmallPanel;
